import { handleCheckStatus, handleGetProjectList, handleWelcome } from '@/api/grt/personalRecommend';
import { isInApp } from '../Mobile';
import { linkApp } from '../Mobile';
import ToastUtils from '../ToastUtils';
import { getEnvironment, envMap } from '../Mobile';
const openInNewTab = (url) => {
    setTimeout(() => {
        let env = getEnvironment();
        if (env) {
            window.top.open(url);
        } else {
            window.open(url);
        }
    }, 50);
};
export const goDetailPage = (data, side = 'mobile') => {
    const env = getEnvironment();
    if (env === envMap.app) {
        linkApp(`grtedu://jump_template?template_id=${data?.template_id}&business_id=${data?.business_id}`);
        return;
    }
    let { template_id = 104, business_id } = data;
    let url = `${window.location.origin}/mobile/detail?template_id=${template_id}&business_id=${business_id}&course_type=${template_id}`;

    if (side === 'web' || env === envMap.pc) {
        url = `${window.location.origin}/web/business-detail?template_id=${template_id}&business_id=${business_id}&course_type=${template_id}`;
    }
    openInNewTab(url);
};
export const goBusinessIndex = (data, side = 'mobile') => {
    const env = getEnvironment();
    if (env === envMap.app) {
        linkApp(`grtedu://jump_study_template?template_id=${data?.template_id}&business_id=${data?.business_id}`);
        return;
    }
    let { template_id = 104, business_id } = data;
    let url = `${window.location.origin}/mobile/teach-business?template_id=${template_id}&business_id=${business_id}&course_type=${template_id}`;

    if (side === 'web' || env === envMap.pc) {
        url = `${window.location.origin}/web/${template_id}/${business_id}/home`;
    }
    openInNewTab(url);
};
export const handleGetWelcome = async () => {
    let res = await handleWelcome({});
    if (res && res.success) {
        return res?.data || '';
    } else {
        ToastUtils.showAbnormalToast(res.msg || '操作失败');
        return '';
    }
};
//获取项目列表通过点播课id
export const handleGetProjectListByCourseId = async (params, side = 'mobile') => {
    let res = await handleGetProjectList(params);
    if (res && res.success) {
        if (res?.data.length === 1) {
            let item = res?.data[0];
            console.log(item, '哈哈');
            if (item.in_project === 1) {
                goDetailPage({ ...item }, side);
            } else {
                goBusinessIndex(item, side);
            }
            // goDetailPage({ ...item }, side);
            return [];
        }
        return res?.data || [];
    } else {
        return [];
    }
};
//校验业务状态
export const handleCheckBusinessStatus = async (data, side = 'mobile') => {
    let res = await handleCheckStatus(data);
    if (res && res.success) {
        if (res?.data === 1) {
            goDetailPage(data, side);
        } else {
            goBusinessIndex(data, side);
        }

        return true;
    } else {
        ToastUtils.showAbnormalToast(res.msg || '操作失败');
        return false;
    }
};
